import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/soul";
import { Users } from "lucide-react";

export default function Community() {
  const [reflections, setReflections] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/reflections/community").then((r) => {
      setReflections(r.data.reflections || []);
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  return (
    <main data-testid="community-page" className="max-w-5xl mx-auto px-6 py-16">
      <div className="max-w-3xl mb-12 fade-up">
        <p className="text-[#D4AF37] tracking-[0.3em] uppercase text-xs mb-4 flex items-center gap-2">
          <Users size={14} /> Community Reflections
        </p>
        <h1 className="serif text-4xl sm:text-6xl font-light text-[#F5F1E7]">
          What others <span className="italic-serif text-[#D4AF37]">received</span>
        </h1>
        <p className="mt-5 text-[#A8A29E] leading-relaxed text-lg">
          Truths that fellow seekers found in the words, shared so we may encourage one another on the way inward.
        </p>
      </div>

      {loaded && reflections.length === 0 ? (
        <div className="glass rounded-2xl p-12 text-[#A8A29E]">
          <p className="italic-serif text-xl">No shared reflections yet. Be the first to encourage others.</p>
          <Link to="/red-letters" className="mt-4 inline-block text-[#D4AF37] hover:underline">
            Sit with the Red Letters →
          </Link>
        </div>
      ) : (
        <div className="space-y-5" data-testid="community-list">
          {reflections.map((rf, i) => (
            <div
              key={i}
              data-testid="community-reflection"
              className="glass rounded-2xl p-7 border-l-2"
              style={{ borderLeftColor: "#D4AF37" }}
            >
              <p className="italic-serif text-lg text-[#C1272D] leading-snug">“{rf.verse_text}”</p>
              <p className="text-xs text-[#A8A29E] mt-1 mb-4">— {rf.verse_ref}</p>
              <p className="text-[#F5F1E7] leading-relaxed text-lg">{rf.note}</p>
              <p className="mt-3 text-sm text-[#D4AF37]">— {rf.author_name || "A fellow seeker"}</p>
            </div>
          ))}
        </div>
      )}
    </main>
  );
}
